import * as React from "react";
import {Spin} from "antd";


function Suspense () {
    return(
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            minHeight: '100vh'
        }}>
            <Spin size="large" tip="Loading..."/>
        </div>
    )
}

export default Suspense